import { jsxs as o, jsx as e } from "react/jsx-runtime";
import h from "react";
import { ItemWrapper as $, Input as s, Label as a, Circle as x, InnerCircle as I, TextWrapper as _, Text as j, Subtitle as C } from "./styled.js";
const S = ({
  onChange: c,
  setValue: l,
  name: i,
  label: d,
  value: r,
  subtitle: t,
  checked: m = !1,
  disabled: p = !1,
  inputProps: n,
  wrapperProps: f
}) => /* @__PURE__ */ o($, { $hasSubtitle: !!t, ...f, children: [
  /* @__PURE__ */ e(
    s,
    {
      ...n,
      type: "radio",
      disabled: p,
      checked: m,
      onChange: () => {
        l(r), c && c(r);
      },
      value: r,
      id: `${i}_${r}`,
      name: i
    }
  ),
  /* @__PURE__ */ o(a, { htmlFor: `${i}_${r}`, $subtitle: t, $label: d, children: [
    /* @__PURE__ */ e(x, { children: /* @__PURE__ */ e(I, {}) }),
    /* @__PURE__ */ o(_, { children: [
      /* @__PURE__ */ e(j, { children: d }),
      t && /* @__PURE__ */ e(C, { children: t })
    ] })
  ] })
] }), y = h.memo(S);
export {
  y as default
};
